(() => {
  if (customElements.get('product-review-carousel')) return;
  customElements.define('product-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.pr15-track');
      const prev = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const status = this.querySelector('[data-review-position]');
      if (!track || !prev || !next) return;
      const cards = [...track.children];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const stride = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = Math.max(1, Math.min(cards.length, Math.round(track.scrollLeft / Math.max(1, stride())) + 1));
        status.textContent = `${first} of ${cards.length} ${this.dataset.itemLabel || 'reviews'}`;
        prev.disabled = next.disabled = max < 2;
      };
      const move = direction => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        let target = track.scrollLeft + direction * stride();
        if (direction > 0 && track.scrollLeft >= max - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = max;
        track.scrollTo({left: Math.max(0, Math.min(max, target)), behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      const previous = () => move(-1), following = () => move(1);
      const keyboard = event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      };
      let timer;
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => {
        stop();
        if (this.dataset.autoplay === 'true' && !reduced.matches && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) {
          timer = setInterval(() => {
            const box = this.getBoundingClientRect();
            if (box.bottom > 0 && box.top < innerHeight) move(1);
          }, 6000);
        }
      };
      const focusOut = () => queueMicrotask(start);
      prev.addEventListener('click', previous); next.addEventListener('click', following);
      track.addEventListener('scroll', update, {passive:true}); track.addEventListener('keydown', keyboard);
      this.addEventListener('mouseenter', stop); this.addEventListener('mouseleave', start);
      this.addEventListener('focusin', stop); this.addEventListener('focusout', focusOut);
      document.addEventListener('visibilitychange', start); reduced.addEventListener('change', start);
      const resize = new ResizeObserver(update); resize.observe(track);
      this.cleanup = () => {
        stop(); resize.disconnect();
        prev.removeEventListener('click', previous); next.removeEventListener('click', following);
        track.removeEventListener('scroll', update); track.removeEventListener('keydown', keyboard);
        this.removeEventListener('mouseenter', stop); this.removeEventListener('mouseleave', start);
        this.removeEventListener('focusin', stop); this.removeEventListener('focusout', focusOut);
        document.removeEventListener('visibilitychange', start); reduced.removeEventListener('change', start);
      };
      update(); start();
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
})();
